// ****************************************************
// Import images here, and export the image identifier.
// ****************************************************

import microscopeMan from './microscope-man-2018-05-30.svg'
import osqueryTerminalListeningPorts from './osquery-terminal-listening-ports-2018-05-30.png'
import osqueryTextLogo from './osquery-text-logo-2018-05-30.png'

export default {
  microscopeMan,
  osqueryTerminalListeningPorts,
  osqueryTextLogo,
}
